
import { useState } from "react";

export const usePhotoCarousel = (photos: string[]) => {
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  
  const validPhotos = photos?.length > 0 ? photos : ["/placeholder.svg"];

  const nextPhoto = () => {
    setCurrentPhotoIndex((prev) => (prev + 1) % validPhotos.length);
  };

  const prevPhoto = () => {
    setCurrentPhotoIndex((prev) => (prev - 1 + validPhotos.length) % validPhotos.length);
  };

  return {
    currentPhotoIndex,
    photos: validPhotos,
    nextPhoto,
    prevPhoto,
    hasMultiplePhotos: validPhotos.length > 1
  };
};
